import { render, staticRenderFns } from "./now.vue?vue&type=template&id=919edc26&scoped=true&"
import script from "./now.vue?vue&type=script&lang=js&"
export * from "./now.vue?vue&type=script&lang=js&"
import style0 from "./now.vue?vue&type=style&index=0&id=919edc26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919edc26",
  null
  
)

export default component.exports